import { useState } from 'react';
import { FORM_ENDPOINT, FORM_FIELDS, channels } from './data';
import { SocialIcon } from './Icons';
import SectionHead from './SectionHead';

const EMPTY = { name: '', email: '', subject: '', message: '' };

function channelProps(href) {
  if (href.startsWith('http')) return { target: '_blank', rel: 'noreferrer noopener' };
  return {};
}

export default function Contact() {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState('');

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setSending(true);
    setStatus('');
    const body = new FormData();
    body.append(FORM_FIELDS.name, form.name);
    body.append(FORM_FIELDS.email, form.email);
    body.append(FORM_FIELDS.subject, form.subject);
    body.append(FORM_FIELDS.message, form.message);

    try {
      await fetch(FORM_ENDPOINT, { method: 'POST', mode: 'no-cors', body });
      setStatus('success');
      setForm(EMPTY);
    } catch {
      setStatus('error');
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="section" id="contact">
      <div className="wrap">
        <SectionHead
          index="05"
          label="Contact"
          title="Get in touch."
          lede="Email, phone, WhatsApp, or a short note."
        />
        <div className="contact__grid">
          <div className="channels">
            {channels.map((channel) => (
              <a key={channel.id} className="channel" href={channel.href} {...channelProps(channel.href)}>
                <span className="channel__icon">
                  <SocialIcon name={channel.label === 'WhatsApp' ? 'WhatsApp' : channel.label} />
                </span>
                <span>
                  <strong>{channel.label}</strong>
                  <em>{channel.value}</em>
                </span>
              </a>
            ))}
          </div>
          <form className="form" onSubmit={onSubmit}>
            {status === 'success' ? (
              <p className="form__status" role="status">
                Sent. I will reply to the email you left.
              </p>
            ) : null}
            {status === 'error' ? (
              <p className="form__status is-error" role="status">
                That did not go through. Email ayushkumawat2112@gmail.com and it will reach me.
              </p>
            ) : null}
            <label>
              Name
              <input name="name" autoComplete="name" value={form.name} onChange={onChange} required maxLength={80} />
            </label>
            <label>
              Email
              <input
                name="email"
                type="email"
                autoComplete="email"
                value={form.email}
                onChange={onChange}
                required
                maxLength={120}
              />
            </label>
            <label>
              Subject
              <input name="subject" value={form.subject} onChange={onChange} required maxLength={140} />
            </label>
            <label>
              Message
              <textarea name="message" value={form.message} onChange={onChange} required maxLength={2000} rows={6} />
            </label>
            <button className="btn btn--solid" type="submit" disabled={sending}>
              {sending ? 'Sending' : 'Send message'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
